import React from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'antd';

const { Panel } = Collapse;

const RDCollapse = ({
  collapseItem,
  onChange,
  accordion,
  bordered,
  ghost,
  defaultActiveKey,
  expandIcon,
}) => (
  <Collapse
    onChange={onChange}
    accordion={accordion}
    bordered={bordered}
    ghost={ghost}
    defaultActiveKey={defaultActiveKey}
    expandIcon={expandIcon}
    collapseItem={collapseItem}
  >
    {collapseItem.map(({ panelTitle, panelText, key, showArrow, collapsible }) => (
      <Panel header={panelTitle} key={key} showArrow={showArrow} collapsible={collapsible}>
        {panelText}
      </Panel>
    ))}
  </Collapse>
);

RDCollapse.defaultProps = {
  collapseItem: [],
  defaultActiveKey: '',
  expandIcon: undefined,
  accordion: false,
  bordered: true,
  ghost: false,
  onChange: () => {},
};

RDCollapse.propTypes = {
  /** Specifies item inside Collapse */
  collapseItem: PropTypes.arrayOf(PropTypes.shape({})),
  /** Specifies the Key of the initial active panel */
  defaultActiveKey: PropTypes.string,
  /** used to customize collapse icon */
  expandIcon: PropTypes.element,
  /** If true, only one panel can be expanded at a time */
  accordion: PropTypes.bool,
  /** Toggles rendering of the border around the collapse block */
  bordered: PropTypes.bool,
  /** Make collapse borderless and its background transparent */
  ghost: PropTypes.bool,
  /** Callback function executed when active panel is changed */
  onChange: PropTypes.func,
};

export default RDCollapse;
